import * as React from 'react';
import * as styles from './styles.css';
import { Text } from '../Typography/components';
export interface IFormFieldProps {
  htmlFor?: string;
  label?: string;
  description?: string;
  errorText?: string;
  children: React.ReactNode;
}

export const FormField: React.FC<IFormFieldProps> = props => {
  const { description, htmlFor, errorText, label, children } = props;

  return (
    <label htmlFor={htmlFor} className={styles['container']}>
      {label && (
        <Text level={5} color="primary">
          {label}
        </Text>
      )}
      {children}
      {description && (
        <Text level={4} color="secondary">
          {description}
        </Text>
      )}
      {errorText && (
        <Text level={4} color="error">
          {errorText}
        </Text>
      )}
    </label>
  );
};

FormField.displayName = 'FormField';
